export const inBrowser = typeof window !== 'undefined'
export const UA = inBrowser && window.navigator.userAgent.toLowerCase()

export const isAndroid = UA && UA.indexOf('android') > 0
export const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA)
export const isPC = UA && !isAndroid && !isIOS
export function isWechatMiniProgram () {
  return window.__wxjs_environment === 'miniprogram'
}
